import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { TState } from 'redux/config/root-types'
import { Actions_Modals } from 'redux/modules/modals/Actions'
import { Actions_TrackerCodes } from 'redux/modules/trackerCodes/Actions'
import { I18nModal } from 'utils/i18n/i18nModal'

export const useTrackerCodeDelete = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation(I18nModal.trackerCodeDelete)

  const id = useSelector(({ modals }: TState) => modals.data?.id)

  const onSubmit = () => {
    dispatch(Actions_TrackerCodes.saga.deleteTrackerCode({ id }))
    dispatch(Actions_Modals.store.hideModal())
  }

  const onCancel = () => dispatch(Actions_Modals.store.hideModal())

  return { t, onSubmit, onCancel }
}
